import { render, staticRenderFns } from "./Ascension.vue?vue&type=template&id=bb35dbca&scoped=true&"
import script from "./Ascension.vue?vue&type=script&lang=js&"
export * from "./Ascension.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb35dbca",
  null
  
)

export default component.exports